import React, { useState } from "react";
import {
  MDBFile,
  MDBCard,
  MDBCardBody,
  MDBCardTitle,
  MDBCheckbox,
  MDBValidation,
  MDBTextArea,
  MDBBtn,
  MDBInput,
} from "mdb-react-ui-kit";

import { useSelector } from "react-redux";
import axios from "axios";
import validateTemplateBase64Data from "../../utilities/validateTemplateBase64Data";
import { toast } from "react-toastify";
import fingerPrintServices from "../../utilities/demo";
import Loader from "../Loader";
import convertToUnderscoreFormat from "../../utilities/convertToUnderscoreFormat";
import ScannerLoader from "../ScannerLoader";
import API_BASE_URL from "../../utilities/apiConfig";
import EligibleMembersTable from "./EligibleMembersTable";
import CompletedVotingTable from "./CompletedVotingTable";
import REPORT_BASE_URL from "../../utilities/reportConfig";
import axiosInstance from "../../utilities/apiConfig";
const GenrateVotingList = () => {
  const [barId, setBarid] = useState("");
  const [loading, setLoading] = useState(false);
  const [fingerprintverified, setfingerprintVerified] = useState("");
  const [userFingerprint, setUserFingerprint] = useState("");
  const [secugenLic, setSecugenLic] = useState("");
  const [quality, setQuality] = useState(100);
  const [eligibleMembersData, setEligibleMembersData] = useState("");
  const [votingCompletionData, setVotingCompletionData] = useState("");
  const [pageNo, setPageNo] = useState(1);
  const [isFingerPrintScannerinProgress, setIsFingerPrintScannerinProgress] =
    useState(false);

  const userDeatils = useSelector((state) => state.auth?.userData?.authUser);

  const { userId, fingerprintData } = userDeatils;

  const fingerPrintService = fingerPrintServices();

  const eligibleMembersColumns = [
    {
      field: "eligibilityId",
      headerName: "Eligibility ID",
      minWidth: 150,
      flex: 1,
      align: "left",
      headerAlign: "left",
    },
    {
      field: "advocateBarId",
      headerName: "Advocate Bar ID",
      minWidth: 150,
      flex: 1,
      align: "left",
      headerAlign: "left",
    },
    {
      field: "name",
      headerName: "Name",
      minWidth: 150,
      flex: 1,
      align: "left",
      headerAlign: "left",
    },
    {
      field: "relationshipType",
      headerName: "Relationship Type",
      minWidth: 150,
      flex: 1,
      align: "left",
      headerAlign: "left",
    },
    {
      field: "relativeName",
      headerName: "Relative Name",
      minWidth: 150,
      flex: 1,
      align: "left",
      headerAlign: "left",
    },
    // { field: 'barAssociationId', headerName: 'Bar Association ID', type: 'number', minWidth: 150, flex: 1, align: 'left', headerAlign: 'left' },

    {
      field: "mobileno",
      headerName: "Mobile Number",
      minWidth: 150,
      flex: 1,
      align: "left",
      headerAlign: "left",
    },
    // { field: 'email', headerName: 'Email', minWidth: 180, flex: 1, align: 'left', headerAlign: 'left' },
    // { field: 'permanentAddress', headerName: 'Permanent Address', minWidth: 200, flex: 1, align: 'left', headerAlign: 'left' },
    // { field: 'appliedDate', headerName: 'Applied Date', type: 'text', minWidth: 150, flex: 1, align: 'left', headerAlign: 'left' },
    // { field: 'requestedTimePreiodDate', headerName: 'Eligibility Date', type: 'text', minWidth: 150, flex: 1, align: 'left', headerAlign: 'left' },
    // { field: 'daysLeft', headerName: 'Days Left', type: 'number', minWidth: 150, flex: 1, align: 'left', headerAlign: 'left' },
    // { field: 'dateOfBirth', headerName: 'Date of Birth', type: 'text', minWidth: 150, flex: 1, align: 'left', headerAlign: 'left' },
    // { field: 'bloodGroup', headerName: 'Blood Group', minWidth: 120, flex: 1, align: 'left', headerAlign: 'left' },
    // { field: 'isPreviousDepartment', headerName: 'Previous Department', type: 'boolean', minWidth: 150, flex: 1, align: 'left', headerAlign: 'left' },
    // { field: 'previousDepartment', headerName: 'Previous Department', minWidth: 180, flex: 1, align: 'left', headerAlign: 'left' },
    // { field: 'retirementYear', headerName: 'Retirement Year', type: 'number', minWidth: 150, flex: 1, align: 'left', headerAlign: 'left' },
    // { field: 'mentorAdvocateBarId', headerName: 'Mentor Advocate Bar ID', minWidth: 180, flex: 1, align: 'left', headerAlign: 'left' },
    // { field: 'mentorAdvocateName', headerName: 'Mentor Advocate Name', minWidth: 180, flex: 1, align: 'left', headerAlign: 'left' },
    // { field: 'mentorJoiningDate', headerName: 'Mentor Joining Date', type: 'text', minWidth: 180, flex: 1, align: 'left', headerAlign: 'left' },
    // { field: 'chamberNumber', headerName: 'Chamber Number', minWidth: 150, flex: 1, align: 'left', headerAlign: 'left' },
    // { field: 'pendingRequestId', headerName: 'Pending Request ID', type: 'number', minWidth: 150, flex: 1, align: 'left', headerAlign: 'left' },
    // { field: 'aadharDocument', headerName: 'Aadhar Document', minWidth: 200, flex: 1, align: 'left', headerAlign: 'left' },
    // { field: 'affidavitDocument', headerName: 'Affidavit Document', minWidth: 200, flex: 1, align: 'left', headerAlign: 'left' },
    // { field: 'highSchoolDocument', headerName: 'High School Document', minWidth: 200, flex: 1, align: 'left', headerAlign: 'left' },
    // { field: 'intermediateDocument', headerName: 'Intermediate Document', minWidth: 200, flex: 1, align: 'left', headerAlign: 'left' },
    // { field: 'graduationDocument', headerName: 'Graduation Document', minWidth: 200, flex: 1, align: 'left', headerAlign: 'left' },
    // { field: 'postGraduationDocument', headerName: 'Post Graduation Document', minWidth: 200, flex: 1, align: 'left', headerAlign: 'left' },
    // { field: 'doctorateDocument', headerName: 'Doctorate Document', minWidth: 200, flex: 1, align: 'left', headerAlign: 'left' },
    // { field: 'status', headerName: 'Status', minWidth: 150, flex: 1, align: 'left', headerAlign: 'left' }
  ];

  const votingCompletionColumns = [
    {
      field: "votingSerialNo",
      headerName: "Voting Serial No",
      minWidth: 150,
      flex: 1,
      align: "left",
      headerAlign: "left",
    },
    {
      field: "advocateBarId",
      headerName: "Advocate Bar ID",
      minWidth: 150,
      flex: 1,
      align: "left",
      headerAlign: "left",
    },
    {
      field: "name",
      headerName: "Name",
      minWidth: 150,
      flex: 1,
      align: "left",
      headerAlign: "left",
    },
    {
      field: "relationshipType",
      headerName: "Relationship Type",
      minWidth: 150,
      flex: 1,
      align: "left",
      headerAlign: "left",
    },
    {
      field: "relativeName",
      headerName: "Relative Name",
      minWidth: 150,
      flex: 1,
      align: "left",
      headerAlign: "left",
    },
    // { field: 'dateOfBirth', headerName: 'Date of Birth',  minWidth: 150, flex: 1, align: 'left', headerAlign: 'left' },
    {
      field: "mobileno",
      headerName: "Mobile Number",
      minWidth: 150,
      flex: 1,
      align: "left",
      headerAlign: "left",
    },
    // Uncomment and adjust as needed
    // { field: 'barAssociationId', headerName: 'Bar Association ID', minWidth: 150, flex: 1, align: 'left', headerAlign: 'left' },
    // { field: 'advocateAlternateBarId', headerName: 'Alternate Bar ID', minWidth: 150, flex: 1, align: 'left', headerAlign: 'left' },
    // { field: 'permanentAddress', headerName: 'Permanent Address', minWidth: 200, flex: 1, align: 'left', headerAlign: 'left' },
    // { field: 'localAddress', headerName: 'Local Address', minWidth: 200, flex: 1, align: 'left', headerAlign: 'left' },
    // { field: 'photo', headerName: 'Photo', minWidth: 150, flex: 1, align: 'left', headerAlign: 'left' },
    // { field: 'fingerprint', headerName: 'Fingerprint', minWidth: 150, flex: 1, align: 'left', headerAlign: 'left' },
    // { field: 'signature', headerName: 'Signature', minWidth: 150, flex: 1, align: 'left', headerAlign: 'left' },
    // { field: 'fingerprintImage', headerName: 'Fingerprint Image', minWidth: 150, flex: 1, align: 'left', headerAlign: 'left' },
    // { field: 'isFeesPaid', headerName: 'Fees Paid', type: 'boolean', minWidth: 150, flex: 1, align: 'left', headerAlign: 'left' },
    // { field: 'isVerificationCompleted', headerName: 'Verification Completed', type: 'boolean', minWidth: 200, flex: 1, align: 'left', headerAlign: 'left' },
    // { field: 'verificationDate', headerName: 'Verification Date', type: 'date', minWidth: 200, flex: 1, align: 'left', headerAlign: 'left' },
    // { field: 'votingDate', headerName: 'Voting Date', type: 'date', minWidth: 200, flex: 1, align: 'left', headerAlign: 'left' },
    // { field: 'status', headerName: 'Status', minWidth: 150, flex: 1, align: 'left', headerAlign: 'left' },
    // { field: 'userId', headerName: 'User ID', minWidth: 150, flex: 1, align: 'left', headerAlign: 'left' },
  ];

  const successFunc2 = (result) => {
    setIsFingerPrintScannerinProgress(false);
    if (
      result.ErrorCode === 0 &&
      result != null &&
      result.BMPBase64.length > 0
    ) {
      console.log("Finger Print Data", result.TemplateBase64);
      setUserFingerprint(result.TemplateBase64);
      console.log("Finger Print Image", result.BMPBase64);

      handleVerifyFingerPrint(result.TemplateBase64, fingerprintData);
    } else {
      if (result.ErrorCode === 3) {
        toast.error("Please check your fingerprint device");
      } else if (result.ErrorCode === 54) {
        toast.error("Timeout, scan your finger again");
      } else {
        toast.error("Please scan your finger again");
      }
    }
  };

  // Error callback function
  const errorFunc = (status) => {
    setIsFingerPrintScannerinProgress(false);
    toast.error("Please Check Secugen fingerprit service is working properly");
    // toast.error(`Check if SGIBIOSRV is running; status = ${status}:`);
  };

  const callSGIFPGetData = () => {
    setIsFingerPrintScannerinProgress(true);
    const uri = "https://localhost:8000/SGIFPCapture";
    const params = new URLSearchParams({
      Timeout: 10000,
      Quality: 50,
      licstr: secugenLic,
      templateFormat: "ISO",
    });

    axios
      .post(uri, params, {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      })
      .then((response) => {
        successFunc2(response.data);
      })
      .catch((error) => {
        errorFunc(error);
      });
  };

  const handleVerifyFingerPrint = async (userFingerprint, fingerprintData) => {
    try {
      const condition1 = validateTemplateBase64Data(fingerprintData);
      const condition2 = validateTemplateBase64Data(userFingerprint);
      console.log(condition1);
      if (condition1 && condition2) {
        const response = await fingerPrintService.matchFingerPrint(
          fingerprintData,
          userFingerprint,
          fingerPrintService.succMatch,
          fingerPrintService.failureFunc
        );
        console.log("Response of Matching:", response);
        if (response.matched) {
          handleGenrateVotingList();
        } else {
          toast.error("FingerPrint Not Matched");
        }
      } else {
        toast.error("Please scan your fingerprint again");
      }
    } catch (error) {
      console.error("Error:", error);
      toast.error("Error : Finger Data Not Verified");
      // Handle the error here
    } finally {
    }
  };

  const handleGetAllEligbleVotersList = async (referenceBarId) => {
    if (referenceBarId !== null) {
      const formatted_bar_id = convertToUnderscoreFormat(barId);
      try {
        setLoading(true);
        setVotingCompletionData("");
        const response = await axiosInstance.get(
          `/Voting/get_eligible_voter_list_by_user_id/${userId}`
        );
        console.log("API Response:", response.data);
        debugger;
        if (response.data.response.statusCode === 200) {
          toast.success(response.data.response.status);
          setEligibleMembersData(response.data.eligibleMemberVotingList);
        } else {
          toast.error(response.data.response.status);
        }
      } catch (error) {
        console.error("Error deleting records:", error);
        toast.error("An Unexpected Error Occured Please Try again");
      } finally {
        setLoading(false);
      }
    } else {
      toast.error("Please Enter bar id");
    }
  };

  const handleGenrateVotingList = async (referenceBarId) => {
    if (referenceBarId !== null) {
      const formatted_bar_id = convertToUnderscoreFormat(barId);
      try {
        setLoading(true);
        const response = await axiosInstance.get(
          `/Voting/genrate_voting_list_by_user_id/${userId}`
        );
        console.log("API Response:", response.data);
        debugger;
        if (response.data.response.statusCode === 200) {
          toast.success(response.data.response.status);
        } else {
          toast.error(response.data.response.status);
        }
      } catch (error) {
        console.error("Error deleting records:", error);
        toast.error("An Unexpected Error Occured Please Try again");
      } finally {
        setLoading(false);
      }
    } else {
      toast.error("Please Enter bar id");
    }
  };

  const handleGetEligibleVotingList = () => {
    try {
      // Show the loader
      setLoading(true);

      // Open the URL directly in a new tab
      window.open(`${REPORT_BASE_URL}/EligibleVotersNew.aspx`, "_blank");
    } catch (error) {
      console.error("Error opening eligible voting list:", error);
    } finally {
      // Hide the loader
      setLoading(false);
    }
  };

  const handleGetCompletedVotingList = async () => {
    try {
      setLoading(true);
      setEligibleMembersData("");
      const response = await axiosInstance.get(
        `/Voting/get_voting_completion_data`
      );
      console.log(response.data);
      if (response.data.response.statusCode === 200) {
        toast.success(response.data.response.status);
        setVotingCompletionData(response.data.votingCompletions);
      } else {
        toast.error(response.data.response.status);
      }
    } catch (error) {
      console.log(error);
      toast.error("An Unexpeced Error Occured Please try Again after SomeTime");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {loading && <Loader />}
      {isFingerPrintScannerinProgress && <ScannerLoader />}
      <div className="row justify-content-center mb-4  mt-5">
        <div className="col-xxl-8">
          <div className="row text-center">
            <h2>Genrate Voting List And Data Tables related to Voting</h2>
          </div>
        </div>
      </div>
      <div className="mt-5">
        <div className="row mb-5 justify-content-center my-5 pb-5">
          <div className="col-md-6 mb-1 d-flex justify-content-center">
            <MDBBtn
              color="warning"
              className="text-nowrap"
              onClick={() => {
                callSGIFPGetData();
              }}
            >
              Genrate Voting List
            </MDBBtn>
            &nbsp;
            <MDBBtn
              color="danger"
              className="text-nowrap"
              onClick={() => {
                handleGetAllEligbleVotersList();
              }}
            >
              Get Eligible Member Voting List
            </MDBBtn>
            &nbsp;
            <MDBBtn
              color="success"
              onClick={() => {
                handleGetEligibleVotingList();
              }}
            >
              Get Voting List
            </MDBBtn>{" "}
            &nbsp;
            <MDBBtn
              color="info"
              className="text-nowrap"
              onClick={() => {
                handleGetCompletedVotingList();
              }}
            >
              Completed Voting Data Table
            </MDBBtn>
          </div>
        </div>
      </div>

      {eligibleMembersData && (
        <EligibleMembersTable
          tableName="Eligible Members Table"
          TableColumns={eligibleMembersColumns}
          TableData={eligibleMembersData}
          height={700}
        />
      )}

      {votingCompletionData && (
        <CompletedVotingTable
          tableName="Completed Voting Table"
          TableColumns={votingCompletionColumns}
          TableData={votingCompletionData}
          height={700}
        />
      )}
    </>
  );
};

export default GenrateVotingList;
